import React  from 'react';
import UsersComponentProto from './users-proto/users-proto';

export default function renderDateInList(id, props) {
    return <UsersComponentProto renderMode="list" id={id} {...props} />;
}